var _div, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFirouzehWithoutTypo(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _div || (_div = /*#__PURE__*/React.createElement("div", {
    xmlns: "",
    id: "in-page-channel-node-id",
    "data-channel-name": "in_page_channel_3lf3zI"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0415039 15.9305L15.9825 0.0136719L31.9204 16.0277L15.9794 31.9445L0.0415039 15.9305ZM0.96012 15.932L15.9808 31.0244L31.0017 16.0262L15.9811 0.933782L0.96012 15.932Z",
    fill: "#3EC1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89502 8.7685V7.82873C10.2462 9.22368 13.8268 12.1363 15.8501 16.3672C17.7917 12.3319 21.0889 9.2582 26.7758 7.89394V8.79791C21.1949 10.446 17.5606 13.4597 16.4756 18.2697H15.2246C13.8562 12.7334 9.7611 10.299 4.89502 8.7685Z",
    fill: "#3EC1CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8514 3.76281C15.3446 6.33918 14.2353 8.53708 11.7333 9.86043C9.4088 10.9894 7.79273 12.4726 7.42126 15.1781C6.53025 14.93 5.96348 15.2957 5.74009 16.3007C6.83151 16.1 7.6638 17.1574 7.98804 18.7236C8.05314 18.9129 8.11824 19.0254 8.3595 19.0548C9.63347 20.5201 11.15 20.9995 12.826 20.8333C12.6843 21.5186 13.1618 22.2807 15.351 23.48C15.3689 25.4184 15.1506 27.2506 14.543 28.9051H15.5693L15.8527 27.7109L16.1654 28.8693H17.1036C16.5662 27.1611 16.3314 25.371 16.3837 23.4915C18.218 22.5338 19.1269 21.6363 18.8793 20.8026C20.3779 21.0507 21.8587 20.5904 23.3152 19.0829C23.6164 19.0535 23.7581 18.8579 23.7517 18.5216C24.2177 16.9374 24.9491 16.146 25.9997 16.27C25.752 15.3545 25.2031 14.9288 24.2534 15.141C23.799 11.3001 21.1323 10.6327 19.0682 9.26204C17.4228 8.13304 16.3365 6.31361 15.8527 3.76025L15.8514 3.76281ZM15.8514 6.38649C15.3918 8.24173 14.1996 10.1865 12.3231 12.2066C10.1645 15.1973 11.2968 17.9386 15.8514 18.2697C20.4468 17.9808 21.4144 15.0784 19.4384 12.2361C17.4968 10.1213 16.2943 8.17013 15.8514 6.38649Z",
    fill: "#3EC1CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2404 22.631C13.9213 24.3622 12.3818 27.0038 11.3261 26.5307L9.76876 25.839C9.51473 26.7903 9.96918 28.7874 12.5592 27.3516C13.6149 26.6074 14.488 25.325 15.0076 23.0376L14.2404 22.6297V22.631Z",
    fill: "#3EC1CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4904 22.631C17.8095 24.3622 19.349 27.0038 20.4047 26.5307L21.9556 25.839C22.2148 26.7903 21.7603 28.7874 19.1715 27.3516C18.1159 26.6074 17.2427 25.325 16.7232 23.0376L17.4904 22.6297V22.631Z",
    fill: "#3EC1CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFirouzehWithoutTypo);
export default __webpack_public_path__ + "static/media/logo-firouzeh-without-typo.72302155bb061d9f1899ec6afbb54a14.svg";
export { ForwardRef as ReactComponent };